export const scrollToTopSmoothly = () => window.scrollTo({ top: 0, behavior: 'smooth' })
